import Vue from 'vue'
import { http } from '@/services/http'
import qs from 'qs'
import { openOauthInSameTabIfNeeded, generateSuccessLoginResponse } from './helpers'

const login = ({ state, commit, rootState, dispatch }, creds) => {
  return new Promise((resolve, reject) => {
    http
      .post('/api/login', creds)
      .then((response) => {
        commit('AUTH_SUCCESS')
        resolve(generateSuccessLoginResponse(response))
      })
      .catch((error) => reject(error.response.data))
  })
}

const confirmAuthorizationInB2c = ({ state }, { email, mpcCode }) => {
  const payload = JSON.stringify({ email, mpcCode })
  const targetOrigin = '*'
  window.opener.postMessage(payload, targetOrigin)
  window.close()
}

const register = ({ state }, creds) => {
  return new Promise((resolve, reject) => {
    http
      .post('/api/sign_up', creds)
      .then((response) => resolve(response))
      .catch((error) => reject(error.response.data))
  })
}

const passForgot = ({ state }, creds) => {
  return new Promise((resolve, reject) => {
    http
      .post('/api/reset_password', creds)
      .then((response) => resolve(response))
      .catch((error) => reject(error.response.data))
  })
}

const passReset = ({ state }, creds) => {
  return new Promise((resolve, reject) => {
    http
      .patch('/api/reset_password', creds)
      .then((response) => resolve(response))
      .catch((error) => reject(error.response.data))
  })
}

const confirmEmail = ({ state }, request) => {
  return new Promise((resolve, reject) => {
    http
      .get('/api/confirm_email', { params: request })
      .then((response) => resolve(response))
      .catch((error) => reject(error.response.data))
  })
}

const refreshToken = ({ state, commit }, request) => {
  return new Promise((resolve, reject) => {
    if (state.refreshTokenPending) {
      setTimeout(() => { resolve({token: state.token}) }, 400)
    } else if (!state.token) {
      reject({})
    } else {
      commit('REFRESH_TOKEN_PENDING', true)
      http.get('/api/token_refreshes', request)
        .then((response) => {
          commit('STORE_NEW_TOKEN', response.token)
          resolve(response)
        })
        .catch((error) => reject(error.response.data))
    }
  })
}

const authSocial = ({ commit, dispatch }, payload) => {
  let oauthPath = http.defaults.baseURL + '/users/auth/' + payload.provider

  const queryParamsToJoin = {
    punkta_agent: payload.isBroker || undefined,
    parent_mpc_code: payload.parentMpcCode
  }

  const queryParams = qs.stringify(queryParamsToJoin)
  if (queryParams.length) {
    oauthPath += `?${queryParams}`
  }

  openOauthInSameTabIfNeeded(oauthPath)

  const popup = window.open(oauthPath)
  if (popup && popup.focus) {
    popup.focus()
  }

  return new Promise((resolve, reject) => {
    const receiveMessage = (event) => {
      // security for read message only from api origin
      if (event.origin !== http.defaults.baseURL) return

      const token = JSON.parse(event.data).token
      clearInterval(popupInterval)
      window.removeEventListener('message', receiveMessage, false)
      if (token) {
        commit('STORE_TOKEN', token)
        commit('AUTH_SUCCESS')
        resolve(token)
      } else {
        reject({
          errors: {
            message: ['Auth popup window without token']
          }
        })
      }
    }
    window.addEventListener('message', receiveMessage, false)
    let popupInterval = setInterval(() => {
      if (!popup || popup.closed || popup.closed === undefined) {
        clearInterval(popupInterval)
        popupInterval = null
        window.removeEventListener('message', receiveMessage, false)
        reject({
          errors: {
            message: ['Auth popup window closed']
          }
        })
      }
    }, 250)
  })
}

const logout = ({ state, commit }) => {
  return new Promise(resolve => {
    commit('LOGOUT')
    commit('STORE_USER', {})
    Vue.router.push('/logowanie')
    window.location.reload()
  })
}

const auth = ({ state, commit, dispatch }) => {
  return new Promise(resolve => {
    commit('AUTH_SUCCESS')
    resolve()
  })
}

export default {
  login,
  confirmAuthorizationInB2c,
  register,
  passForgot,
  passReset,
  confirmEmail,
  refreshToken,
  authSocial,
  logout,
  auth
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js